<template>
  <SfList
    :data-testid="testId"
    class="tw-border-0 tw-border-b tw-border-solid tw-px-4 tw-pb-4"
    :class="
      inFloatingSidepane
        ? 'tw-border-sf-slate-lighter-1'
        : 'tw-border-sf-slate-lighter-1'
    "
  >
    <slot name="static-item"> </slot>
    <SegmentListItem
      v-for="segment in props.segments"
      :key="segment.id"
      :segment="segment"
      :loading="loading"
      @item-click="itemClick"
    >
    </SegmentListItem>
  </SfList>
</template>

<script setup lang="ts">
import SfList from '@app/shared/vue/components/sf-list/sf-list.vue'
import SegmentListItem from './segment-list-item.vue'
import type { Segment } from '../../types/index'
import { useInsightsLayoutContext } from '../../composables/use-insights-layout-context'

interface Props {
  segments: Array<Segment>
  loading: boolean
  testId: string
}
const props = defineProps<Props>()
const emit =
  defineEmits<{
    'item-click': [value: Segment]
  }>()

const { inFloatingSidepane } = useInsightsLayoutContext()

const itemClick = (segment: Segment): void => {
  emit('item-click', segment)
}
</script>
